export default __webpack_public_path__ + "static/media/trending-post.93742206.png";